import React from "react";
import type { QeddyLauncherProps } from "./QeddyLauncher";

export type QeddyProviderValue = {
  refreshStatus: () => void;
  launcher?: QeddyLauncherProps;
  /** Öffnet Qeddy und stellt die Frage sofort, z. B. aus einer Suche ohne passenden Treffer. */
  ask?: (question: string) => void;
};

const QeddyContext = React.createContext<QeddyProviderValue | null>(null);

export function QeddyProvider({ value, children }: { value: QeddyProviderValue; children: React.ReactNode }) {
  return <QeddyContext.Provider value={value}>{children}</QeddyContext.Provider>;
}

export function useQeddyProvider() {
  return React.useContext(QeddyContext);
}
